.title {
  font-size: 18px;
  font-weight: 700;
  color: #bebebe;
}
